import './index.less'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react';

const UserCenter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const [showChildren, setShowChildren] = useState(true);
  const menuList = [
    {
      label: '个人信息',
      pathName: 'user-info',
      children: []
    },
    {
      label: '历史记录',
      pathName: 'history',
      children: [
        {
          label: '浏览记录',
          pathName: 'browse-records'
        }
      ]
    },
    {
      label: '我的问题',
      pathName: 'my-question',
      children: []
    },
    {
      label: '我的关注',
      pathName: 'my-follow',
      children: []
    },
    {
      label: '我的收藏',
      pathName: 'my-collect',
      children: []
    },
  ]
  const goPage = (pathName: string) => {
    navigate(`/user-center/${pathName}`)
  }

  return <div className='user-center-container'>
    <div className='user-center-container-aside'>
      {
        menuList.map((item) => {
          if (item.children.length) {
            return (
              <div className={`has-children ${showChildren ? '' : 'hide'}`} key={item.pathName}>
                <div className='aside-menu-item' onClick={() => setShowChildren(!showChildren)}>
                  <span>
                    {item.label}
                  </span>
                  <img src={require('@/assets/images/arrow-down.png')} alt="" />
                </div>
                {
                  item.children.map((child) => {
                    return <div className={`aside-menu-item ${pathname.includes(child.pathName) ? 'active' : ''}`} key={child.pathName} onClick={() => goPage(child.pathName)}>
                      <span>{child.label}</span>
                    </div>
                  })
                }
              </div>
            )
          } else {
            return (
              <div className={`aside-menu-item ${pathname.includes(item.pathName) ? 'active' : ''}`} key={item.pathName} onClick={() => goPage(item.pathName)}>
                <span>
                  {item.label}
                </span>
              </div>
            )
          }
        })
      }
    </div>
    <div className='user-center-container-main'>
      <Outlet/>
    </div>
  </div>
}

export default UserCenter;